<template>
  <div class="container-fluid m-0 p-0">
    <div class="row bg-light text-left border-top border-bottom py-2 ml-1">
      <div class="col-sm-12 h-100 my-auto p-0 m-0">
        <span class="mx-3 font-weight-bold lead">Port List</span>
        <span class="mx-3">
          <button class="btn btn-sm btn-outline-primary font-weight-bolder"
                  data-toggle="modal"
                  data-target="#add-port"
          >
            <span class="fas fa-plus"></span>
            Add Port
          </button>
        </span>
        <span class="float-right py-1 mx-2 pr-4">
          <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                  @click="goBack"
          >
            <span class="fas fa-backward"></span>
            Go Back
          </button>
        </span>
      </div>
    </div>

    <div class="row text-small pt-3">
      <div class="col col-md-12" style="min-height: 450px !important;">
        <div class="form-group form-inline">
          <label for="inputUser" class="pr-3 font-weight-bold">Search Port Here: </label>
          <input class="form-control form-control-sm mr-2 w-25" id="inputUser" style=""
                 type="text" placeholder="Input Any Here . . ."
                 v-model="searchValue"
                 @input="setPage(1)"
          >
          <button type="button" class="btn btn-primary btn-sm"
                  @click="searchValue = ''; setPage(1)"
          >CLEAR</button>

          <label for="country-id" class="pr-3 font-weight-bold ml-5">Country: </label>
          <select id="country-id" class="form-control form-control-xs input-group-append"
                  v-model="countryId"
                  @change="setPage(0)"
          >
            <option :value="null">--- All Country ---</option>
            <option v-for="countryKey in countryKeys"
                    :key="countryKey.id"
                    :value="countryKey.id"
            >{{ countryKey.name }}</option>
          </select>

        </div>

        <div class=" table-responsive text-small" style="height: 475px;">
          <table  class="table table-hover table-bordered table-template-1 text-small sticky-header">
            <thead>
            <tr>
              <th>#</th>
              <th class="col-name">PORT CODE</th>
              <th>PORT NAME</th>
              <th>COUNTRY</th>
              <th>STATUS</th>
              <th class="col-actions">ACTION</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(port, index) in ports" :key="port.id" :class="{ inactive: !port.active }">
              <td>{{ index + pagination.from }}</td>
              <td>{{ port.code }}</td>
              <td>{{ port.name }}</td>
              <td>{{ port.countryName }}</td>
              <td>{{ port.active ? 'ACTIVE' : 'INACTIVE' }}</td>
              <td class="text-center col-actions">
                <button class="btn btn-sm btn-xs btn-warning font-weight-bolder mr-1 ml-auto"
                        data-toggle="modal"
                        data-target="#edit-port"
                        @click="viewPort(port)"
                >
                  <span class="fas fa-edit"></span>
                  Edit
                </button>
                <button class="btn btn-sm btn-xs btn-outline-danger font-weight-bolder mr-1 ml-auto"
                        @click="confirmDeletePort(port)"
                >
                  <span class="fas fa-trash-alt"></span>
                  Delete
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>

      <nav aria-label="..." class="ml-3 pt-2">
        <ul class="pagination text-smallest">
          <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
            <button class="page-link" @click="setPage(1)">First</button>
          </li>

          <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
            <button class="page-link" @click="setPage(page)">{{ page }}</button>
          </li>

          <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
            <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
          </li>
        </ul>
      </nav>

    </div>

    <app-modal unique="edit-port" title="EDIT PORT DETAILS">

      <form @submit.prevent="confirmUpdatePort">
          <div class="form-group form-row mb-1" :class="{'has-error': editPortErrors.code }">
            <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="port-code" >
              Port Code:
            </label>
            <div class="col col-sm-7">
              <input type="text" id="port-code"
                     class="form-control form-control-xs"
                     placeholder="PORT CODE NOT SPECIFIED"
                     v-model="editPort.code"
              >
              <span class="help-block" v-if="editPortErrors.code !== ''">
                  <small><strong>{{ editPortErrors.code }}</strong></small>
              </span>
            </div>
          </div>

          <div class="form-group form-row mb-1" :class="{'has-error': editPortErrors.name }">
              <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="port-name" >
                Port Name:
              </label>

              <div class="col col-sm-7">
                <input type="text" id="port-name"
                       class="form-control form-control-xs"
                       placeholder="PORT NAME NOT SPECIFIED"
                       v-model="editPort.name"
                >
                <span class="help-block" v-if="editPortErrors.name !== ''">
                    <small><strong>{{ editPortErrors.name }}</strong></small>
                </span>
              </div>
          </div>

          <div class="form-group form-row mb-1" :class="{'has-error': editPortErrors.country_id }">
              <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="port-country" >
                Country:
              </label>

              <div class="col col-sm-7">
                <select id="port-country" class="form-control form-control-xs input-group-append"
                        v-model="editPort.country_id"
                >
                  <option :value="null">--- No Country ---</option>
                  <option v-for="countryKey in countryKeys"
                          :key="countryKey.id"
                          :value="countryKey.id"
                  >{{ countryKey.name }}</option>
                </select>
                <span class="help-block" v-if="editPortErrors.country_id !== ''">
                    <small><strong>{{ editPortErrors.country_id }}</strong></small>
                </span>
              </div>
          </div>

          <div class="form-group form-row mb-1" :class="{'has-error': editPortErrors.active }">
              <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="port-status" >
                Status:
              </label>
              <div class="col col-sm-7">
                <div class="form-check d-block">
                  <select class="form-control form-control-xs" id="port-status" v-model="editPort.active">
                    <option value="">Select..</option>
                    <option :value="true">ACTIVE</option>
                    <option :value="false">INACTIVE</option>
                  </select>
                </div>
                <span class="help-block" v-if="editPortErrors.active !== ''">
                    <small><strong>{{ editPortErrors.active }}</strong></small>
                </span>
              </div>
          </div>

          <hr style="border-color: #E0DED7"/>
          <button type="submit" class="btn btn-sm btn-warning font-weight-bolder float-right">
            <span class="fas fa-edit"></span>
            Update
          </button>

      </form>
    </app-modal>

    <app-modal unique="add-port" title="ADD PORT">

      <form @submit.prevent="confirmAddPort">
        <div class="form-group form-row mb-1" :class="{'has-error': newPortErrors.code }">
          <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="new-port-code" >
            Port Code:
          </label>
          <div class="col col-sm-7">
            <input type="text" id="new-port-code"
                   class="form-control form-control-xs"
                   placeholder="SPECIFY PORT CODE HERE"
                   v-model="newPort.code"
            >
            <span class="help-block" v-if="newPortErrors.code !== ''">
                <small><strong>{{ newPortErrors.code }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newPortErrors.name }">
          <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="new-port-name" >
            Port Name:
          </label>

          <div class="col col-sm-7">
            <input type="text" id="new-port-name"
                   class="form-control form-control-xs"
                   placeholder="SPECIFY PORT NAME HERE"
                   v-model="newPort.name"
            >
            <span class="help-block" v-if="newPortErrors.name !== ''">
                <small><strong>{{ newPortErrors.name }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newPortErrors.country_id }">
          <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="new-port-country" >
            Country:
          </label>

          <div class="col col-sm-7">
            <select id="new-port-country" class="form-control form-control-xs input-group-append"
                    v-model="newPort.country_id"
            >
              <option :value="undefined">--- No Country ---</option>
              <option v-for="countryKey in countryKeys"
                      :key="countryKey.id"
                      :value="countryKey.id"
              >{{ countryKey.name }}</option>
            </select>
            <span class="help-block" v-if="newPortErrors.country_id !== ''">
                <small><strong>{{ newPortErrors.country_id }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newPortErrors.active }">
          <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="new-port-status" >
            Status:
          </label>

          <div class="col col-sm-7">
            <div class="form-check d-block">
              <select class="form-control form-control-xs" id="new-port-status" v-model="newPort.active">
                <option value="">Select..</option>
                <option :value="true">ACTIVE</option>
                <option :value="false">INACTIVE</option>
              </select>
            </div>
            <span class="help-block" v-if="newPortErrors.active !== ''">
                    <small><strong>{{ newPortErrors.active }}</strong></small>
                </span>
          </div>
        </div>

        <hr style="border-color: #E0DED7"/>
        <button type="submit" class="btn btn-sm btn-outline-primary font-weight-bolder float-right">
          <span class="fas fa-save"></span>
          SAVE
        </button>

      </form>
    </app-modal>

  </div>
</template>

<script>

import AppModal from "@/components/elements/AppModal";

import { mapGetters, mapActions } from 'vuex';
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { paginationMixin } from "@/mixins/paginationMixin";

export default {
  name: "PortIndex",

  mixins: [ vueAppMixin, paginationMixin ],

  components: { AppModal },

  data() {
    return {
      searchValue: '',
      countryId: null,

      editPort: {},
      editPortErrors: {},

      newPort: {
        active: ''
      },
      newPortErrors: {},

    }
  },

  methods: {
    ...mapActions([
        'getPortList',
        'getCountryKeys',
        'updatePort',
        'addPort',
        'deletePort'
    ]),

    initializeData() {
      this.getPortList({});
      this.getCountryKeys();
    },

    searchPort() {
      let page = this.pagination.currentPage;
      let params = {
        page: page,
        searchValue: this.searchValue,
        countryId: this.countryId,
      };
      this.getPortList(params);
    },

    setPage(page) {
      this.pagination.currentPage = page;
      this.searchPort();
    },

    viewPort(port) {
      this.editPort = Object.assign({}, port);
      this.editPortErrors = {};
    },

    async confirmUpdatePort() {
      if(await this.confirmUpdate()) {
        let params = {
          id: this.editPort.id,
          code: this.editPort.code,
          name: this.editPort.name,
          active: this.editPort.active,
          country_id: this.editPort.country_id,
        };
        let updatedPort = await this.updatePort(params);
        if(updatedPort) {
          if(updatedPort.errors) {
            this.editPortErrors = updatedPort.errors;
          } else {
            this.successAlert('Port Successfully Updated', 'UPDATE');
            this.editPort = {};
            this.editPortErrors = {};
            document.getElementById('close-edit-port').click();
          }
        }
      }
    },

    async confirmAddPort() {
      if(await this.confirmCreateAlert()) {
        let params = {
          code: this.newPort.code,
          name: this.newPort.name,
          active: this.newPort.active,
          country_id: this.newPort.country_id,
        };
        let newPort = await this.addPort(params);
        if(newPort) {
          if(newPort.errors) {
            this.newPortErrors = newPort.errors;
          } else {
            this.successAlert('New Port Successfully Added', 'CREATE');
            this.newPort = {};
            this.newPortErrors = {};
            document.getElementById('close-add-port').click();
          }
        }
      }
    },

    async confirmDeletePort(port) {
      if(await this.confirmDeleteAlert()) {
        let params = { id: port.id };
        let deletedPort = await this.deletePort(params);
        if(deletedPort) {
          this.successAlert('Port Successfully Deleted', 'DELETED');
        }
      }
    }

  },

  computed: {
    ...mapGetters([
        'ports',
        'countryKeys'
    ])
  },

  created() {
    this.initializeData();
  }
}
</script>

<style scoped>

</style>
